
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal",
      function () {
        return require("private-next-pages/legal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal"])
      });
    }
  